/**
 * SearchIcon Component
 * 
 * This component is renders Search Icon for autocomplete field
 * 
 * */

import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Icon } from './AutoComplete.styled';
import SearchGrayInactive from 'src/assets/images/SearchGrayInactive.svg';

export default function SearchIcon({
    isProductSearch = false,
    isAddItemSearchItem = false,
    showSearchIcon = false,
    Search,
    searchIconHeight,
    searchIconWidth,
    disabled,
    onChange,
}) {
    return (
        <InputAdornment position="start">
            <Icon
            id="autocomplete-search-icon"
                isAddItemSearchItem={isAddItemSearchItem}
                showSearchIcon={showSearchIcon}
                src={isAddItemSearchItem || isProductSearch? SearchGrayInactive : Search}
                height={searchIconHeight}
                width={searchIconWidth}
                onClick={() => (!disabled ? onChange('') : null)}
            />
        </InputAdornment>
    );
}